import { render, staticRenderFns } from "./CardSign.vue?vue&type=template&id=2b83c43f&"
import script from "./CardSign.vue?vue&type=script&lang=js&"
export * from "./CardSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports